import Dto from "../../../../../../service/Dto";

class ReadMailTemplates extends Dto {

  campaignId = '';

  constructor(campaignId = '', _class = 'campaign\\module\\modules\\ustore\\v002\\service\\dto\\ReadMailTemplates') {
    super(_class);
    this.campaignId = campaignId;
  }

  getCampaignId() {
    return this.campaignId;
  }

  setCampaignId(campaignId) {
    this.campaignId = campaignId;
  }
}

export default ReadMailTemplates;
